// extracted by mini-css-extract-plugin
module.exports = {"code":"styles_code__idLjM"};